export enum Z_INDEX_VALUES {
    CARD = 1198,
    NAV_BAR = 1300,
    DIALOG = 1310,
    TOOLTIP = 1311,
    POPOVER = 1312,
    SELECT = 1313,
    TOAST = 1450,
}
// Keep class names static (no string interpolation).
// Dialogs above nav bar/MUI (1300). Tooltips/select above dialogs. Toasts above notistack (1400).
export enum Z_INDEX_CLASS_NAMES {
    CARD = "z-[1198]",
    DIALOG = "z-[1310]",
    TOOLTIP = "z-[1311]",
    POPOVER = "z-[1312]",
    SELECT = "z-[1313]",
    TOAST = "z-[1450]",
}
